
import User from './User';

export default User;



// WEBPACK FOOTER //
// ./src/API/User/index.js